import React from "react";
import { BRAND } from "../mock";
import BrandLogo from "./BrandLogo";
import MemberOnlyBadge from "./MemberOnlyBadge";

export default function Footer() {
  return (
    <footer className="bg-navy text-white py-10 mt-0">
      <div className="max-w-6xl mx-auto px-6 flex flex-col items-center md:items-stretch md:flex-row md:justify-between gap-6">
        <BrandLogo variant="yellow" className="h-10" />
        <div className="flex flex-col md:flex-row items-center gap-4 text-sm">
          <div className="flex items-center gap-3">
            <span className="text-white/35 text-xs uppercase tracking-[0.18em]">Studio tools</span>
            <a
              href="/chords"
              data-testid="footer-chords-link"
              className="text-white/80 hover:text-paul-yellow transition-colors inline-flex items-center gap-2"
            >
              Chord Atlas
              <MemberOnlyBadge size="xs" />
            </a>
          </div>
          <span className="hidden md:inline text-white/15">·</span>
          <p className="text-white/70">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
        </div>
        <a
          href={`mailto:${BRAND.email}`}
          className="text-sm text-white/80 hover:text-paul-yellow transition-colors"
        >
          {BRAND.email}
        </a>
      </div>
    </footer>
  );
}
